import { Component, OnInit, Input, Output, EventEmitter, ViewChild, } from '@angular/core';
import { CommonService } from '../services/common.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { GestionSygetrack } from '../../recylog/application/gestion.sygetrack';
import * as moment from 'moment';

@Component({
  selector: 'app-fiche-chantier',
  templateUrl: './fiche-chantier.component.html',
  styleUrls: ['./fiche-chantier.component.css']
})
export class FicheChantierComponent implements OnInit {


  @Input() chantier;
  @Input() client;
  @Input() flux2;
  @Input() edit: Boolean;
  @Input() prospectHolding: Boolean;
  @Input() add: Boolean;
  @Input() hideDetenteur: Boolean;
  @Input() disablemodif: Boolean;
  @Input() isTypeDetenteur: Boolean;
  searchCritere = '';
  listeagence: any[] = [];
  listeterritoire: any[] = [];
  isEmpty: Boolean = false;
  isRecherche: Boolean = false;
  isCreate: Boolean = false;
  isModif: Boolean = false;

  isGeneral: Boolean = false;
  isSupp: Boolean = false;
  isFact: Boolean = false;
  isDoc: Boolean = false;
  isAmiante: Boolean = false;
  isDetenteur: Boolean = false;
  error = '';
  societe: any = {};

  @Output() hidefunction = new EventEmitter<any>();
  @Output() validefunction = new EventEmitter<any>();
  @Output() addfunction = new EventEmitter<any>();

  //sygetrack
  msgSygetrack = '';
  arg1FuncAfterSygetrack; // idChantier
  arg2FuncAfterSygetrack; // bool create log
  nomInformatiqueImbrique = 'Sygetrack'; // Par défaut
  @ViewChild('loadingSygetrack') loadingSygetrack;
  resultTypeHabitat : any[] = [];

  @ViewChild('msg') msg;
  @ViewChild('choixTypeHabitat') choixTypeHabitat;
  
  constructor(protected common: CommonService, private modalService: BsModalService) { }

  ngOnInit() {
    console.log('isTypeDetenteur', this.isTypeDetenteur)
    const societe = this.common.local.getObject('paramSociete') || {};
    this.societe = societe;
    const TypeHabitat = this.common.getType('typeHabitat') || [];
    this.resultTypeHabitat = TypeHabitat || [];
    const chantierParSite = this.common.local.getObject('paramSociete').chantierParSite ? true : false;
    if (chantierParSite) {
      this.chantier['siteChantier'] = {};
      this.chantier['siteChantier'].id = this.common.user[2];
    }
    if (this.client.id && !this.prospectHolding) {
      this.getDetailClient(this.client.id);
    }

    this.chantier['client'] = this.chantier['client'] || this.client;

    if (this.chantier['zone'] && this.chantier['zone'].id) {
      const list = this.common.getType('typezone') || [];
      list.forEach(element => {
        if (element.id === this.chantier['zone'].id) {
          this.chantier['zone'] = element;
        }
      });
    }
    console.log(this.client);

    const site = this.common.getType('siteUtilisateur');
    const adresseAutoBAK = site['rechercheAdresse'] && (site['serviceAdresse'] &&
      site['serviceAdresse'].typeServiceAdresse &&
      site['serviceAdresse'].typeServiceAdresse.id === 2) ? true : false;
    const varadresseAutoBAK = (societe['rechercheAdresse'] && (societe['serviceAdresse'] &&
      societe['serviceAdresse'].typeServiceAdresse &&
      societe['serviceAdresse'].typeServiceAdresse.id === 2)) || adresseAutoBAK;

    if (this.chantier && this.chantier['id'] > 0 && this.chantier['clefBAK']) {
      this.common.getDetailBak(varadresseAutoBAK, this.chantier['clefBAK']).then(cht => {
        if (this.common.bak && this.common.bak['id'] && this.societe['isBAKRI']) {
          this.chantier['complementAdresse1'] = this.chantier['complementAdresse1'] || this.common.bak.batiment;
          this.chantier['complementAdresse2'] = this.chantier['complementAdresse2'] || this.common.bak.etage;
          this.chantier['typeHabitat'] = this.common.bak.typeHabitat || { id: 0 };
          this.chantier['refCadastrale'] = this.common.bak.refCadastrale;
          this.chantier['numInvariant'] = this.common.bak.numInvariant;
        }
      });
    }


    this.getAgence();
    this.getTypeTerritoire();
    const ctrl = this;
    setTimeout(function () {
      $('#ficheinput2').focus();
      ctrl.common.closeAllAutocomplete();
      ctrl.closeAllDropdown();
    }, 600);
    this.isGeneral = this.isOngletGeneralVisible();
    this.isSupp = this.isOngletSuppVisible();
    this.isFact = this.isOngletFactVisible();
    this.isDoc = this.isOngletDocVisible();
    this.isAmiante = this.isOngletAmianteVisible();
    this.isDetenteur = societe.clientCollectivite && this.isOngletDetVisible();
    if (!this.chantier['lieuChantierSelect']) {
      this.chantier['lieuChantierSelect'] = {};
    } else {
      this.chantier['lieuChantierSelect'].libelleObjetEntite = this.chantier['lieuChantierSelect'].nom || '';
    }

    this.getNomInformatiqueEmbarque();
  }

  getNomInformatiqueEmbarque() {
    if (this.common.isSiteSygetrack()) {
      const ctrl = this;
      GestionSygetrack.getNomInformatiqueEmbarque(this.common).then(datas => {
        ctrl.nomInformatiqueImbrique = datas.data;
      });
    }
  }

  isInformatiqueEmbarqueSimplicity() {
    return this.nomInformatiqueImbrique == 'Simplicity';
  }

  closeAllDropdown() {
    console.log($('app-entrees .tourneeComponent app-autocomplete .dropdown-menu'))
    $('app-entrees .tourneeComponent app-autocomplete .dropdown-menu').removeClass('show');
    $('app-entrees .tourneeComponent app-autocomplete .dropdown-menu').addClass(' hide');
  }

  showFiche() {
    this.hidefunction.emit();
  }

  filtreSearch(event) {
    this.changeInput(event.target.value);
  }

  changeRecherche() {
    if (!this.searchCritere.length) {
      this.isRecherche = false;
    }
  }

  changeInput(indexSelected) {
    const matcher = new RegExp(indexSelected, 'gi');
    if (indexSelected.length) {
      this.isRecherche = true;
    } else {
      this.isRecherche = false;
    }
    $('.info-client .items').show().not(function () {
      return matcher.test($(this).find('.champ').text());
    }).hide();
    if (!$('.group1').find('.items:visible').length) {
      $('.group1 h4').hide();
    } else {
      $('.group1 h4').show();
    }
    if (!$('.group2').find('.items:visible').length) {
      $('.group2 h4').hide();
    } else {
      $('.group2 h4').show();
    }
    if (!$('.group3').find('.items:visible').length) {
      $('.group3 h4').hide();
    } else {
      $('.group3 h4').show();
    }
    if (!$('.group4').find('.items:visible').length) {
      $('.group4 h4').hide();
    } else {
      $('.group4 h4').show();
    }
    if (!$('.group5').find('.items:visible').length) {
      $('.group5 h4').hide();
    } else {
      $('.group5 h4').show();
    }
  }

  getAgence() {
    // selon client
    const param = {
      'servlet': 'DBAgenceGet',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.chantier.client ? this.chantier.client.id : '0'
        },
        'CRITERE': ''
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.listeagence = datas.data;
    });
  }

  editChantier() {
    this.edit = !this.edit;
  }

  getTypeTerritoire() {
    // service
    const param = {
      'servlet': 'DBGestionTypeTerritoire',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        }
      }
    };

    this.common.post('', { param: param }).then(datas => {
      this.listeterritoire = datas.data;
    });
  }

  /*updateChantier() {
    // nomclass = Chantier
    this.validefunction.emit(this.chantier);
  }*/

  createChantier() {
    if (this.client) {
      this.chantier['clefClient'] = this.client['id'] || 0;
    }
    this.chantier['codeChantier'] = this.chantier['codeChantier'] || '';
    this.chantier['numBadgeImprime'] = this.chantier['numBadgeImprime'] || '';
    this.chantier['motifVolePerdu'] = this.chantier['motifVolePerdu'] || '';
    this.chantier['proprietaire'] = this.chantier['proprietaire'] || false;
    this.chantier['justificatifDomicile'] = this.chantier['justificatifDomicile'] || { id: 0 };
    this.chantier['dateFin'] = this.chantier['dateFin'] || '31/12/9999';
    // Vérification du N. Chantier
    if ((!this.chantier['numChantier'] || this.chantier['numChantier'] === '') && this.isTypeDetenteur) {
      this.error = 'Le champ Nom Detenteur est obligatoire';
      this.common.openModal(this.modalService, this.msg);
      return;
    }
    if (!this.chantier['numChantier'] || this.chantier['numChantier'] === '') {
      this.error = 'Le champ N. Chantier est obligatoire';
      this.common.openModal(this.modalService, this.msg);
      return;
    }



    if ((!this.chantier['adresse1'] || this.chantier['adresse1'] === '')) {
      this.error = 'Le champ adresse est obligatoire';
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if ((!this.chantier['codePostal'] || this.chantier['codePostal'] === '')) {
      this.error = 'Le champ Code Postal est obligatoire';
      this.common.openModal(this.modalService, this.msg);
      return;
    }
    if ((!this.chantier['ville'] || this.chantier['ville'] === '')) {
      this.error = 'Le champ ville est obligatoire';
      this.common.openModal(this.modalService, this.msg);
      return;
    } else {
      console.log(this.chantier['ville']);
      const type = /^\d/.test(this.chantier['ville'] || '') ? true : false;
      if (type) {
        this.error = 'La ville ne peut pas commencer par un chiffre';
        this.common.openModal(this.modalService, this.msg);
        return;
      }
    }

    if (this.societe.clientCollectivite && this.common.isBAK) {
      if (!this.chantier['typeHabitat'] ||  this.chantier['typeHabitat'] && !this.chantier['typeHabitat'].id) {
        this.chantier['typeHabitat'] = this.resultTypeHabitat.length? this.resultTypeHabitat[0] : {}
         this.common.openModal(this.modalService,this.choixTypeHabitat);
         return false;
      }
    }


    const errorAffiche = this.verificationHour(this.chantier);
    if (errorAffiche) {
      this.error = errorAffiche + ' incorrecte, veuillez entrer une heure au format HH:mm';
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    const validateChampMail = this.validateChampMail();
    if (validateChampMail && validateChampMail != "") {
      this.error = validateChampMail;
      this.common.openModal(this.modalService, this.msg);
      return Promise.resolve(false);
    }

    if (this.chantier.X) {
      const x = '' + this.chantier.X;
      this.chantier.X = x.replace(',', '.');
      this.chantier.X = parseFloat(this.chantier.X);
    }

    if (this.chantier.Y) {
      const y = '' + this.chantier.Y;
      this.chantier.Y = y.replace(',', '.');
      this.chantier.Y = parseFloat(this.chantier.Y);
    }
    console.log(this.client);
    console.log(this.chantier)
    this.addfunction.emit(this.chantier);
  }

  validateChampMail() {
    if (this.common.visibleChamp) {
      this.error = "";
      if (this.common.visibleChamp.cht20) {
        if (this.chantier['mail'] && this.chantier['mail'] != '') {
          if (!this.common.validatePatternMail(this.chantier['mail'])) {
            this.error = "La valeur du champs mail est invalide";
          }
        }
      }

      if (this.common.visibleChamp.cht49) {
        if (this.chantier['mailFact'] && this.chantier['mailFact'] != '') {
          if (!this.common.validatePatternMail(this.chantier['mailFact'])) {
            this.error = "La valeur du champs mail est invalide";
          }
        }
      }

      if (this.common.visibleChamp.cht27) {
        if (this.chantier['mailBSDD'] && this.chantier['mailBSDD'] != '') {
          if (!this.common.validatePatternMail(this.chantier['mailBSDD'])) {
            this.error = "La valeur du champs mail BSDD est invalide";
          }
        }
      }
      return this.error;
    }
  }


  verificationHour(event) {
    if (event.heureDebut) {
      const isDebutValid = moment(event.heureDebut, ['HH:mm', 'HH:mm:ss'], true).isValid();

      if (isDebutValid) {
        event.heureDebut = moment(event.heureDebut, ['HH:mm', 'HH:mm:ss']).format('HH:mm:ss');
      } else {
        return 'Heure d\'ouverture';
      }
    }

    if (event.heureFin) {
      const isFinValid = moment(event.heureFin, ['HH:mm', 'HH:mm:ss'], true).isValid();

      if (isFinValid) {
        event.heureFin = moment(event.heureFin, ['HH:mm', 'HH:mm:ss']).format('HH:mm:ss');
      } else {
        return 'Heure de fermeture';
      }
    }

    if (event.fermeMidi) {
      if (event.heureDebutMidi) {
        const isDebutMidiValid = moment(event.heureDebutMidi, ['HH:mm', 'HH:mm:ss'], true).isValid();

        if (isDebutMidiValid) {
          event.heureDebutMidi = moment(event.heureDebutMidi, ['HH:mm', 'HH:mm:ss']).format('HH:mm:ss');
        } else {
          return 'H. d\'ouverture le midi';
        }
      }

      if (event.heureFinMidi) {
        const isFinMidiValid = moment(event.heureFinMidi, ['HH:mm', 'HH:mm:ss'], true).isValid();

        if (isFinMidiValid) {
          event.heureFinMidi = moment(event.heureFinMidi, ['HH:mm', 'HH:mm:ss']).format('HH:mm:ss');
        } else {
          return 'H. de fermeture le midi';
        }
      }
    }

    return null;
  }

  updateChantier(event) {

    // Vérification du N. Chantier
    if (!event['numChantier'] || event['numChantier'] === '') {
      this.error = 'Le champ N. Chantier est obligatoire';
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if ((!event['adresse1'] || event['adresse1'] === '')) {
      this.error = 'Le champ adresse est obligatoire';
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if ((!event['codePostal'] || event['codePostal'] === '')) {
      this.error = 'Le champ Code Postal est obligatoire';
      this.common.openModal(this.modalService, this.msg);
      return;
    }
    if ((!event['ville'] || event['ville'] === '')) {
      this.error = 'Le champ ville est obligatoire';
      this.common.openModal(this.modalService, this.msg);
      return;
    } else {
      console.log(this.chantier['ville']);
      const type = /^\d/.test(this.chantier['ville'] || '') ? true : false;
      if (type) {
        this.error = 'La ville ne peut pas commencer par un chiffre';
        this.common.openModal(this.modalService, this.msg);
        return;
      }
    }

    if (this.societe.clientCollectivite && this.common.isBAK) {
      if (!this.chantier['typeHabitat'] ||  this.chantier['typeHabitat'] && !this.chantier['typeHabitat'].id) {
        this.chantier['typeHabitat'] = this.resultTypeHabitat.length? this.resultTypeHabitat[0] : {}
         this.common.openModal(this.modalService,this.choixTypeHabitat);
         return false;
      }
    }


    const validateChampMail = this.validateChampMail();
    if (validateChampMail && validateChampMail != "") {
      this.error = validateChampMail;
      this.common.openModal(this.modalService, this.msg);
      return Promise.resolve(false);
    }


    const dateDebutVisible = this.common.visibleChamp.cht77 && this.societe.clientCollectivite;
    const dateFinVisible = this.common.visibleChamp.cht5;
    const isDateChantierObligatoire = this.societe.isDateChantierObligatoire || false;
    const numChantier2Visible = this.common.visibleChamp.cht2;

    if (isDateChantierObligatoire && numChantier2Visible && (!event['numChantier2'] || event['numChantier2'] === '')) {
      this.error = 'Le champs N° Chantier est obligatoire';
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if (isDateChantierObligatoire && dateDebutVisible && (!event['dateDebut'] || !moment(event['dateDebut'], 'DD/MM/YYYY').isValid())) {
      this.error = 'Le champs date début est obligatoire';
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    if (isDateChantierObligatoire && dateFinVisible && (!event['dateFin'] || !moment(event['dateFin'], 'DD/MM/YYYY').isValid())) {
      this.error = 'Le champs date fin est obligatoire';
      this.common.openModal(this.modalService, this.msg);
      return;
    }

    const errorAffiche = this.verificationHour(event)
    if (errorAffiche) {
      this.error = errorAffiche + ' incorrecte, veuillez entrer une heure au format HH:mm';

      this.common.openModal(this.modalService, this.msg);
      return;
    }

    event['codeChantier'] = event['codeChantier'] || '';
    event['numBadgeImprime'] = event['numBadgeImprime'] || '';
    event['motifVolePerdu'] = event['motifVolePerdu'] || '';
    event['proprietaire'] = event['proprietaire'] || false;
    event['justificatifDomicile'] = event['justificatifDomicile'] || { id: 0 };
    event['dateFin'] = event['dateFin'] || '31/12/9999';
    event.nomclass = 'Chantier';
    const client = event.client;
    delete event['client'];
    console.log(event);
    if (!this.client['prospectHolding']) {
      const param = {
        'servlet': 'DBSaveChantierHolding',
        'module': 'Recylog',
        'type': 'liste',
        'compression': 'false',
        'data': ['', event, {
          id: client ? (client.id || 0) : 0,
          nomclass: 'Client'
        }]
      };
      $('.ficheChantier').hide();
      this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          if (datas.data !== null) {
            this.arg1FuncAfterSygetrack = event.id;
            this.arg2FuncAfterSygetrack = true;

            console.log('datas.data.length = ' + (datas.data.length ? 'true' : 'false'));
            console.log('this.common.isSiteSygetrack() = ' + (this.common.isSiteSygetrack() ? 'true' : 'false'));
            console.log('!this.isInformatiqueEmbarqueSimplicity() = ' + (!this.isInformatiqueEmbarqueSimplicity() ? 'true' : 'false'));

            if (datas.data.length && this.common.isSiteSygetrack() && !this.isInformatiqueEmbarqueSimplicity()) {
              this.setPOI(datas.data[0]);
            } else {
              this.suiteRetourUpdateChantier();
            }
          }
        }
      }).catch(err => {
        event['client'] = this.client;
        $('.ficheChantier').show();
      });
    } else {
      this.client['nomclass'] = 'Client';
      const param = {
        'HOLDING_SERVLET': 'DBGestionProspect',
        'HOLDING_MODULE': 'Recylog',
        'HOLDING_TYPE': 'map',
        'HOLDING_COMPRESSION': 'false',
        'CHANTIER': event,
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 8
        },
        'CLIENT': this.client,
      };
      $('.ficheChantier').hide();
      return this.common.DBGestionAppelHolding(param).then(datas => {
        if (this.common.verifySession(datas)) {
          if (datas.data !== null) {
            this.arg1FuncAfterSygetrack = event.id;
            this.arg2FuncAfterSygetrack = false;

            console.log('datas.data.length = ' + (datas.data.length ? 'true' : 'false'));
            console.log('this.common.isSiteSygetrack() = ' + (this.common.isSiteSygetrack() ? 'true' : 'false'));
            console.log('!this.isInformatiqueEmbarqueSimplicity() = ' + (!this.isInformatiqueEmbarqueSimplicity() ? 'true' : 'false'));

            if (datas.data.length && this.common.isSiteSygetrack() && !this.isInformatiqueEmbarqueSimplicity()) {
              this.setPOI(datas.data[0]);
            } else {
              this.suiteRetourUpdateChantier();
            }
          }
        }
      });
    }

  }

  getDetailChantier(id) {
    const param = {
      'servlet': 'DBGetChantier',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetChantier', id]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        return datas;
      }
    });
  }

  getDetailClient(id) {
    const param = {
      'servlet': 'DBGetClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'true',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': id || 0
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'LOAD_CHANTIER': {
          'typeParam': 'boolean',
          'valeur': false
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      this.client = datas.data[0];
    });
  }

  copieAdresse() {
    console.log(this.client);
    if (this.client && this.client['clefBAK']) {
      this.chantier['clefBAK'] = this.client['clefBAK'];
    }
    this.chantier['adresse1'] = this.client['adresse1'] || '';
    this.chantier['adresse2'] = this.client['adresse2'] || '';
    this.chantier['adresse3'] = this.client['adresse3'] || '';
    this.chantier['codePostal'] = this.client['codePostal'] || '';
    this.chantier['ville'] = this.client['ville'] || '';
    this.searchCPVilleEcorec(this.chantier['codePostal']).then(data => {
      data.forEach(element => {
        if (element.codePostal === this.chantier['codePostal'] &&
          this.chantier['ville'] === element.ville) {
          const obj = element;
          if (this.societe['zoneCommune']) {
            if (typeof obj === 'object') {
              this.chantier['zone'] = obj.zone || { id: 0, libelle: '' };
            }
          }
        }
      });
    })
    console.log(this.chantier);
  }

  searchCPVilleEcorec(event) {
    const param = {
      'servlet': 'DBCodePostalVilleGetListParCP',
      'module': 'Recylog',
      'type': 'string',
      'compression': 'false',
      'data': event
    };

    return this.common.post('', { param: param }).then(datas => {
      return datas.data;
    });
  }


  createAgence() {
    this.isCreate = !this.isCreate;
    if (!this.isCreate) {
      this.getAgence();
      const adresseAutoBAK = this.societe['rechercheAdresse'] && (this.societe['serviceAdresse'] &&
        this.societe['serviceAdresse'].typeServiceAdresse && this.societe['serviceAdresse'].typeServiceAdresse.id === 2);
      this.common.getDetailBak(adresseAutoBAK, this.chantier['clefBAK']).then(cht => {
        if (this.common.bak && this.common.bak['id'] && this.societe['isBAKRI']) {
          this.chantier['complementAdresse1'] = this.chantier['complementAdresse1'] || this.common.bak.batiment;
          this.chantier['complementAdresse2'] = this.chantier['complementAdresse2'] || this.common.bak.etage;
          this.chantier['typeHabitat'] = this.common.bak.typeHabitat || { id: 0 };
          this.chantier['refCadastrale'] = this.common.bak.refCadastrale;
          this.chantier['numInvariant'] = this.common.bak.numInvariant;
        }
      });
    }
  }

  editAgence() {
    this.isModif = !this.isModif;
    if (!this.isModif) {
      this.getAgence();
      const adresseAutoBAK = this.societe['rechercheAdresse'] && (this.societe['serviceAdresse'] &&
        this.societe['serviceAdresse'].typeServiceAdresse && this.societe['serviceAdresse'].typeServiceAdresse.id === 2);
      this.common.getDetailBak(adresseAutoBAK, this.chantier['clefBAK']).then(cht => {
        if (this.common.bak && this.common.bak['id'] && this.societe['isBAKRI']) {
          this.chantier['complementAdresse1'] = this.chantier['complementAdresse1'] || this.common.bak.batiment;
          this.chantier['complementAdresse2'] = this.chantier['complementAdresse2'] || this.common.bak.etage;
          this.chantier['typeHabitat'] = this.common.bak.typeHabitat || { id: 0 };
          this.chantier['refCadastrale'] = this.common.bak.refCadastrale;
          this.chantier['numInvariant'] = this.common.bak.numInvariant;
        }
      });
    }
  }

  getValue(event) {
    event.libelleObjetEntite = event.nom;
    this.chantier['agence'] = event;
  }

  isOngletGeneralVisible() {
    let visible = false;
    const listGen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 77];
    listGen.forEach(i => {
      const param = 'cht' + i;
      if (this.common.visibleChamp[param]) {
        visible = true;
      }
    });
    return (visible)
  }

  isOngletSuppVisible() {
    let visible = false;
    const listGen = []
    for (let i = 17; i <= 41; i++) {
      const param = 'cht' + i;
      if (this.common.visibleChamp[param]) {
        visible = true;
      }
    }
    return (visible)
  }

  isOngletFactVisible() {
    let visible = false;
    const listGen = []
    for (let i = 42; i <= 49; i++) {
      const param = 'cht' + i;
      if (this.common.visibleChamp[param]) {
        visible = true;
      }
    }
    return (visible)
  }

  isOngletDocVisible() {
    let visible = false;
    const listGen = []
    for (let i = 50; i <= 50; i++) {
      const param = 'cht' + i;
      if (this.common.visibleChamp[param]) {
        visible = true;
      }
    }
    return (visible)
  }

  isOngletAmianteVisible() {
    let visible = false;
    const listGen = []
    for (let i = 51; i <= 52; i++) {
      const param = 'cht' + i;
      if (this.common.visibleChamp[param]) {
        visible = true;
      }
    }
    return (visible)
  }

  isOngletDetVisible() {
    let visible = false;
    const listGen = []
    for (let i = 53; i <= 70; i++) {
      const param = 'cht' + i;
      if (this.common.visibleChamp[param]) {
        visible = true;
      }
    }
    return (visible)
  }

  // Fermer fenetre sygetrack
  closeSygetrack() {
    this.msgSygetrack = '';
    this.common.closeModal();
    this.suiteRetourUpdateChantier();
  }

  // traitement après click bouton fermer sygetrack
  suiteRetourUpdateChantier() {
    this.validefunction.emit(this.chantier);
    this.showFiche();

    if (this.arg2FuncAfterSygetrack) {
      this.common.createLog('108', this.arg1FuncAfterSygetrack, false);
    }
  }

  // synchroniser modification chantier sur sygetrack
  setPOI(id) {
    this.common.openModal(this.modalService, this.loadingSygetrack);
    return GestionSygetrack.setPOI(id, this.common).then(datas => {
      if (datas.data && datas.data['erreur']) {
        this.msgSygetrack = datas.data['erreur'];

        // Pour debug
        if (datas.data['url']) {
          console.log('URL SYGETRACK SET_POI : ' + datas.data['url']);
        }
      } else {
        this.closeSygetrack();
      }
    });
  }

}
